import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── CIRCLE CARD ──────────────────────────────────────────────────────────────
// Product photo sits in a perfect circle centered on a soft pastel square
// card — a badge-like, boutique-catalog feel distinct from every rectangular
// or wave-shaped style already in the set.
export default function CircleCard({ p, onNav, accent }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const [hovered, setHovered] = useState(false);
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div
      onClick={()=>onNav("product", p.id)}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      style={{
        borderRadius:20, cursor:"pointer", textAlign:"center", padding:"26px 16px 18px",
        background:`${accent}12`,
        boxShadow: hovered ? `0 16px 34px ${accent}30` : "none",
        transform: hovered ? "translateY(-5px)" : "translateY(0)",
        transition:"all 0.3s ease",
      }}>
      <div style={{ position:"relative", width:150, height:150, margin:"0 auto 14px" }}>
        <div style={{ width:"100%", height:"100%", borderRadius:"50%", overflow:"hidden", background:"white", border:`3px solid white`, boxShadow:`0 8px 22px ${accent}40`, transform:hovered?"scale(1.06)":"scale(1)", transition:"transform 0.35s ease" }}>
          {p.img
            ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"top" }} loading="lazy"/>
            : <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:36, opacity:0.25 }}>{meta.emoji}</div>
          }
        </div>
        {disc > 0 && (
          <span style={{ position:"absolute", bottom:2, right:2, background:accent, color:"white", fontSize:9, fontWeight:800, padding:"4px 9px", borderRadius:20, boxShadow:"0 4px 10px rgba(0,0,0,0.2)" }}>
            -{disc}%
          </span>
        )}
        <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
          style={{ position:"absolute", top:2, right:2, background:"white", border:"none", borderRadius:"50%", width:26, height:26, fontSize:12, cursor:"pointer", boxShadow:"0 2px 8px rgba(0,0,0,0.15)" }}>
          {wished ? "❤️" : "🤍"}
        </button>
      </div>
      <div style={{ fontWeight:700, fontSize:13, color:"#1a1a2e", marginBottom:4, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.name}</div>
      <div style={{ fontSize:14.5, fontWeight:900, color:accent, marginBottom:10 }}>₹{p.price?.toLocaleString("en-IN")}</div>
      {p.stock > 0 && (
        <button onClick={addCart} style={{ background:accent, color:"white", border:"none", padding:"7px 20px", borderRadius:20, fontSize:10.5, fontWeight:800, cursor:"pointer" }}>+ Add to Cart</button>
      )}
    </div>
  );
}
